import React from 'react';
import GamesImportGamesModal from './GamesImportGamesModal';

export default function GamesList(): React.ReactNode {
  return <GamesImportGamesModal />;
}
